/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/edit/business-hours/business-hours.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/core/logger.service';
import * as import10 from '@ngx-translate/core/src/translate.service';
import * as import11 from '../../../../../../../public/upgrade/shared/checkbox-container/checkbox-container.component';
import * as import12 from '../../../../shared/checkbox-container/checkbox-container.component.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '../../../../../../../public/upgrade/shared/select-container/select-container.component';
import * as import16 from '../../../../shared/select-container/select-container.component.ngfactory';
import * as import17 from '../../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import18 from '@angular/core/src/linker/template_ref';
import * as import19 from '@angular/common/src/directives/ng_if';
import * as import20 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import21 from '../../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import23 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import24 from '@angular/core/src/linker/element_ref';
import * as import25 from '@angular/common/src/directives/ng_class';
import * as import26 from '@angular/common/src/directives/ng_for';
export class Wrapper_BusinessHoursComponent {
  /*private*/ _eventHandler:Function;
  context:import0.BusinessHoursComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.BusinessHoursComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  check_isEditing(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.isEditing = currValue;
      this._expr_1 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._expr_2 = currValue;
    }
  }
  check_errorMessages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.errorMessages = currValue;
      this._expr_3 = currValue;
    }
  }
  check_data(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.data = currValue;
      this._expr_4 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_BusinessHoursComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_BusinessHoursComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.BusinessHoursComponent>;
  _BusinessHoursComponent_0_3:Wrapper_BusinessHoursComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BusinessHoursComponent_Host0,renderType_BusinessHoursComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'business-hours',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_BusinessHoursComponent0(this.viewUtils,this,0,this._el_0);
    this._BusinessHoursComponent_0_3 = new Wrapper_BusinessHoursComponent(this.injectorGet(import9.LoggerService,this.parentIndex),this.injectorGet(import10.TranslateService,this.parentIndex));
    this.compView_0.create(this._BusinessHoursComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._BusinessHoursComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.BusinessHoursComponent) && (0 === requestNodeIndex))) { return this._BusinessHoursComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._BusinessHoursComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const BusinessHoursComponentNgFactory:import8.ComponentFactory<import0.BusinessHoursComponent> = new import8.ComponentFactory<import0.BusinessHoursComponent>('business-hours',View_BusinessHoursComponent_Host0,import0.BusinessHoursComponent);
const styles_BusinessHoursComponent:any[] = ([] as any[]);
class View_BusinessHoursComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import11.CheckboxContainerComponent>;
  _CheckboxContainerComponent_2_3:import12.Wrapper_CheckboxContainerComponent;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_BusinessHoursComponent1,renderType_BusinessHoursComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm ellipsisText'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import12.View_CheckboxContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._CheckboxContainerComponent_2_3 = new import12.Wrapper_CheckboxContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_2.create(this._CheckboxContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'modelChange',(null as any),'onChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._CheckboxContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true,true);
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import11.CheckboxContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._CheckboxContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = 'DAYS';
    this._CheckboxContainerComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_1:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.value));
    this._CheckboxContainerComponent_2_3.check_label(currVal_2_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_2:any = 'sm';
    this._CheckboxContainerComponent_2_3.check_size(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.dto.days[this.context.$implicit.id];
    this._CheckboxContainerComponent_2_3.check_model(currVal_2_0_3,throwOnChange,false);
    this._CheckboxContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_7:any = this.context.$implicit.id;
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_2,'value',currVal_7);
      this._expr_7 = currVal_7;
    }
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._CheckboxContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto.days[this.context.$implicit.id] = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'onChange')) {
      const pd_sub_1:any = ((<any>this.parentView.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_BusinessHoursComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_4_3:import16.Wrapper_SelectContainerComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  compView_10:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_10_3:import16.Wrapper_SelectContainerComponent;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _pipe_translate_0:import13.TranslatePipe;
  _pipe_translate_1:import13.TranslatePipe;
  _pipe_translate_2:import13.TranslatePipe;
  _pipe_translate_3:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_BusinessHoursComponent2,renderType_BusinessHoursComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import16.View_SelectContainerComponent0(this.viewUtils,this,4,this._el_4);
    this._SelectContainerComponent_4_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_5 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_4.create(this._SelectContainerComponent_4_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_10 = new import16.View_SelectContainerComponent0(this.viewUtils,this,10,this._el_10);
    this._SelectContainerComponent_10_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_11 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_10.create(this._SelectContainerComponent_10_3.context);
    this._text_12 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_4));
    this._SelectContainerComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),false,true);
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_10,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_10));
    this._SelectContainerComponent_10_3.subscribe(this,this.eventHandler(this.handleEvent_10),false,true);
    this._pipe_translate_2 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.SelectContainerComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._SelectContainerComponent_4_3.context; }
    if (((token === import15.SelectContainerComponent) && ((10 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._SelectContainerComponent_10_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_4_0_0:any = 'hour_from_3';
    this._SelectContainerComponent_4_3.check_id(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = 'hour_from_3';
    this._SelectContainerComponent_4_3.check_name(currVal_4_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_2:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('common.FROM'));
    this._SelectContainerComponent_4_3.check_label(currVal_4_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_4_0_3:any = 'md';
    this._SelectContainerComponent_4_3.check_size(currVal_4_0_3,throwOnChange,false);
    const currVal_4_0_4:boolean = !!this.parentView.context.bhValidations.errors['hours2'];
    this._SelectContainerComponent_4_3.check_invalid(currVal_4_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_5:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.context.bhValidations.errors['hours2']));
    this._SelectContainerComponent_4_3.check_invalidText(currVal_4_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_4_0_6:any = this.parentView.context.data.hours;
    this._SelectContainerComponent_4_3.check_list(currVal_4_0_6,throwOnChange,false);
    const currVal_4_0_7:any = this.parentView.context.dto.hourFrom2;
    this._SelectContainerComponent_4_3.check_model(currVal_4_0_7,throwOnChange,false);
    this._SelectContainerComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_10_0_0:any = 'hour_from_4';
    this._SelectContainerComponent_10_3.check_id(currVal_10_0_0,throwOnChange,false);
    const currVal_10_0_1:any = 'hour_from_4';
    this._SelectContainerComponent_10_3.check_name(currVal_10_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_10_0_2:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('common.TO'));
    this._SelectContainerComponent_10_3.check_label(currVal_10_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_10_0_3:any = 'md';
    this._SelectContainerComponent_10_3.check_size(currVal_10_0_3,throwOnChange,false);
    const currVal_10_0_4:boolean = !!this.parentView.context.bhValidations.errors['hours2'];
    this._SelectContainerComponent_10_3.check_invalid(currVal_10_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_10_0_5:any = valUnwrapper.unwrap(this._pipe_translate_3.transform(this.parentView.context.bhValidations.errors['hours2']));
    this._SelectContainerComponent_10_3.check_invalidText(currVal_10_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_10_0_6:any = this.parentView.context.data.hours;
    this._SelectContainerComponent_10_3.check_list(currVal_10_0_6,throwOnChange,false);
    const currVal_10_0_7:any = this.parentView.context.dto.hourTo2;
    this._SelectContainerComponent_10_3.check_model(currVal_10_0_7,throwOnChange,false);
    this._SelectContainerComponent_10_3.ngDoCheck(this,this._el_10,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_10.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_4_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_10_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this.compView_4.destroy();
    this.compView_10.destroy();
    this._SelectContainerComponent_4_3.ngOnDestroy();
    this._SelectContainerComponent_10_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto.hourFrom2 = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_10(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto.hourTo2 = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_BusinessHoursComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_BusinessHoursComponent4,renderType_BusinessHoursComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','eva-3-tag'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'class','tag-text'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','tag-icon eva-3-icon-close'),(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7:any = import3.inlineInterpolate(1,'',(((this.parentView.parentView.context.getFormatedHour(this.parentView.context.$implicit.additionalOpeningHour) + 'hs - ') + this.parentView.parentView.context.getFormatedHour(this.parentView.context.$implicit.additionalClosingHour)) + 'hs'),'');
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_3,currVal_7);
      this._expr_7 = currVal_7;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BusinessHoursComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _vc_23:import14.ViewContainer;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import17.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  _el_29:any;
  _text_30:any;
  _text_31:any;
  /*private*/ _expr_35:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_37:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_BusinessHoursComponent3,renderType_BusinessHoursComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_35 = import1.UNINITIALIZED;
    this._expr_37 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md bottom-border table-rare-row-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-5 -sm-5'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','eva-3-tag'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'span',new import3.InlineArray2(2,'class','tag-text'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                                            ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_4,'i',new import3.InlineArray2(2,'class','tag-icon eva-3-icon-close'),(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n                                        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-5 -sm-5'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'span',new import3.InlineArray2(2,'class','eva-3-tag'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'span',new import3.InlineArray2(2,'class','tag-text'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n                                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_15,'i',new import3.InlineArray2(2,'class','tag-icon eva-3-icon-close'),(null as any));
    this._text_21 = this.renderer.createText(this._el_15,'\n                                        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_23 = new import14.ViewContainer(23,13,this,this._anchor_23);
    this._TemplateRef_23_5 = new import18.TemplateRef_(this,23,this._anchor_23);
    this._NgIf_23_6 = new import17.Wrapper_NgIf(this._vc_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -sm-2 -eva-3-tr -eva-3-pr-lg'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'a',new import3.InlineArray2(2,'class','eva-3-link'),(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_28,'i',new import3.InlineArray2(2,'class','eva-3-icon-trash -eva-3-icon-sm'),(null as any));
    this._text_30 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_28,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_28));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._el_29,
      this._text_30,
      this._text_31
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import19.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_23_0_0:boolean = (!!this.context.$implicit.additionalOpeningHour && !!this.context.$implicit.additionalClosingHour);
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.ngDoCheck(this,this._anchor_23,throwOnChange);
    this._vc_23.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_35:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(('common.week.' + this.context.$implicit.dayOfWeek))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_35,currVal_35))) {
      this.renderer.setText(this._text_7,currVal_35);
      this._expr_35 = currVal_35;
    }
    const currVal_37:any = import3.inlineInterpolate(1,'',(((this.parentView.context.getFormatedHour(this.context.$implicit.openingHour) + 'hs - ') + this.parentView.context.getFormatedHour(this.context.$implicit.closingHour)) + 'hs'),'');
    if (import3.checkBinding(throwOnChange,this._expr_37,currVal_37)) {
      this.renderer.setText(this._text_18,currVal_37);
      this._expr_37 = currVal_37;
    }
  }
  destroyInternal():void {
    this._vc_23.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 23)) { return new View_BusinessHoursComponent4(this.viewUtils,this,23,this._anchor_23,this._vc_23); }
    return (null as any);
  }
  handleEvent_28(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.removeBusinessHour(this.context.$implicit.dayOfWeek)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_BusinessHoursComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_BusinessHoursComponent,{});
export class View_BusinessHoursComponent0 extends import2.AppView<import0.BusinessHoursComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import20.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _NgClass_28_3:import20.Wrapper_NgClass;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  compView_32:import2.AppView<import11.CheckboxContainerComponent>;
  _CheckboxContainerComponent_32_3:import12.Wrapper_CheckboxContainerComponent;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _anchor_36:any;
  /*private*/ _vc_36:import14.ViewContainer;
  _TemplateRef_36_5:any;
  _NgFor_36_6:import21.Wrapper_NgFor;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _el_59:any;
  compView_59:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_59_3:import16.Wrapper_SelectContainerComponent;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _el_65:any;
  compView_65:import2.AppView<import15.SelectContainerComponent>;
  _SelectContainerComponent_65_3:import16.Wrapper_SelectContainerComponent;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _text_73:any;
  _text_74:any;
  _text_75:any;
  _anchor_76:any;
  /*private*/ _vc_76:import14.ViewContainer;
  _TemplateRef_76_5:any;
  _NgIf_76_6:import17.Wrapper_NgIf;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _text_84:any;
  _text_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _text_97:any;
  _text_98:any;
  _el_99:any;
  _text_100:any;
  _el_101:any;
  _text_102:any;
  _text_103:any;
  _text_104:any;
  _el_105:any;
  _text_106:any;
  _el_107:any;
  _text_108:any;
  _text_109:any;
  _text_110:any;
  _anchor_111:any;
  /*private*/ _vc_111:import14.ViewContainer;
  _TemplateRef_111_5:any;
  _NgFor_111_6:import21.Wrapper_NgFor;
  _text_112:any;
  _text_113:any;
  _text_114:any;
  _map_132:any;
  /*private*/ _expr_133:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_135:any;
  _pipe_translate_1:import13.TranslatePipe;
  /*private*/ _expr_137:any;
  _pipe_translate_2:import13.TranslatePipe;
  /*private*/ _expr_139:any;
  _pipe_translate_3:import13.TranslatePipe;
  _map_141:any;
  /*private*/ _expr_142:any;
  _pipe_translate_4:import13.TranslatePipe;
  /*private*/ _expr_144:any;
  _pipe_translate_5:import13.TranslatePipe;
  /*private*/ _expr_146:any;
  _pipe_translate_6:import13.TranslatePipe;
  /*private*/ _expr_148:any;
  _pipe_translate_7:import13.TranslatePipe;
  _pipe_translate_8:import13.TranslatePipe;
  _pipe_translate_9:import13.TranslatePipe;
  _pipe_translate_10:import13.TranslatePipe;
  _pipe_translate_11:import13.TranslatePipe;
  /*private*/ _expr_154:any;
  _pipe_translate_12:import13.TranslatePipe;
  _pipe_translate_13:import13.TranslatePipe;
  /*private*/ _expr_157:any;
  _pipe_translate_14:import13.TranslatePipe;
  /*private*/ _expr_159:any;
  /*private*/ _expr_160:any;
  _pipe_translate_15:import13.TranslatePipe;
  /*private*/ _expr_162:any;
  _pipe_translate_16:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BusinessHoursComponent0,renderType_BusinessHoursComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._map_132 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_133 = import1.UNINITIALIZED;
    this._expr_135 = import1.UNINITIALIZED;
    this._expr_137 = import1.UNINITIALIZED;
    this._expr_139 = import1.UNINITIALIZED;
    this._map_141 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_142 = import1.UNINITIALIZED;
    this._expr_144 = import1.UNINITIALIZED;
    this._expr_146 = import1.UNINITIALIZED;
    this._expr_148 = import1.UNINITIALIZED;
    this._expr_154 = import1.UNINITIALIZED;
    this._expr_157 = import1.UNINITIALIZED;
    this._expr_159 = import1.UNINITIALIZED;
    this._expr_160 = import1.UNINITIALIZED;
    this._expr_162 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_2_3 = new import20.Wrapper_NgClass(this.parentView.injectorGet(import22.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import23.KeyValueDiffers,this.parentIndex),new import24.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','eva-3-row','qadata','daysElement'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_6,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n\n        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','validation-msg -eva-3-mb-sm'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n\n    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._text_27 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_28_3 = new import20.Wrapper_NgClass(this.parentView.injectorGet(import22.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import23.KeyValueDiffers,this.parentIndex),new import24.ElementRef(this._el_28),this.renderer);
    this._text_29 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm ellipsisText'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_32 = new import12.View_CheckboxContainerComponent0(this.viewUtils,this,32,this._el_32);
    this._CheckboxContainerComponent_32_3 = new import12.Wrapper_CheckboxContainerComponent();
    this._text_33 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_32.create(this._CheckboxContainerComponent_32_3.context);
    this._text_34 = this.renderer.createText(this._el_30,'\n            ',(null as any));
    this._text_35 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._anchor_36 = this.renderer.createTemplateAnchor(this._el_28,(null as any));
    this._vc_36 = new import14.ViewContainer(36,28,this,this._anchor_36);
    this._TemplateRef_36_5 = new import18.TemplateRef_(this,36,this._anchor_36);
    this._NgFor_36_6 = new import21.Wrapper_NgFor(this._vc_36.vcRef,this._TemplateRef_36_5,this.parentView.injectorGet(import22.IterableDiffers,this.parentIndex),this.ref);
    this._text_37 = this.renderer.createText(this._el_28,'\n            ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_28,'span',new import3.InlineArray2(2,'class','validation-msg'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'',(null as any));
    this._text_40 = this.renderer.createText(this._el_28,'\n        ',(null as any));
    this._text_41 = this.renderer.createText(this._el_20,'\n    ',(null as any));
    this._text_42 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row  -eva-3-pt-lg'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n        ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n            ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'',(null as any));
    this._text_49 = this.renderer.createText(this._el_45,'\n            ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_45,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'',(null as any));
    this._text_52 = this.renderer.createText(this._el_45,'\n        ',(null as any));
    this._text_53 = this.renderer.createText(this._el_43,'\n    ',(null as any));
    this._text_54 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'\n        ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'\n            ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_57,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_59 = new import16.View_SelectContainerComponent0(this.viewUtils,this,59,this._el_59);
    this._SelectContainerComponent_59_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_60 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_59.create(this._SelectContainerComponent_59_3.context);
    this._text_61 = this.renderer.createText(this._el_57,'\n        ',(null as any));
    this._text_62 = this.renderer.createText(this._el_55,'\n\n        ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n            ',(null as any));
    this._el_65 = import3.createRenderElement(this.renderer,this._el_63,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_65 = new import16.View_SelectContainerComponent0(this.viewUtils,this,65,this._el_65);
    this._SelectContainerComponent_65_3 = new import16.Wrapper_SelectContainerComponent();
    this._text_66 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_65.create(this._SelectContainerComponent_65_3.context);
    this._text_67 = this.renderer.createText(this._el_63,'\n        ',(null as any));
    this._text_68 = this.renderer.createText(this._el_55,'\n        ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_55,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12 -eva-3-pt-xlg'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n            ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'dsp-button',new import3.InlineArray8(6,'qadata','addHours','size','md','variation','ghost'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'',(null as any));
    this._text_73 = this.renderer.createText(this._el_69,'\n        ',(null as any));
    this._text_74 = this.renderer.createText(this._el_55,'\n    ',(null as any));
    this._text_75 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._anchor_76 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_76 = new import14.ViewContainer(76,0,this,this._anchor_76);
    this._TemplateRef_76_5 = new import18.TemplateRef_(this,76,this._anchor_76);
    this._NgIf_76_6 = new import17.Wrapper_NgIf(this._vc_76.vcRef,this._TemplateRef_76_5);
    this._text_77 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'\n        ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_78,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n            ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'dsp-button',new import3.InlineArray8(6,'qadata','saveHours','size','md','variation','ghost'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'',(null as any));
    this._text_84 = this.renderer.createText(this._el_80,'\n        ',(null as any));
    this._text_85 = this.renderer.createText(this._el_78,'\n    ',(null as any));
    this._text_86 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-lg'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'\n        ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_87,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n            ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_89,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-ms bottom-border table-rare-row-fix table-rare-head-fix'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'\n                ',(null as any));
    this._el_93 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-5 -sm-5'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n                    ',(null as any));
    this._el_95 = import3.createRenderElement(this.renderer,this._el_93,'p',new import3.InlineArray2(2,'class','eva-3-p detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'',(null as any));
    this._text_97 = this.renderer.createText(this._el_93,'\n                ',(null as any));
    this._text_98 = this.renderer.createText(this._el_91,'\n                ',(null as any));
    this._el_99 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','col -lg-5 -md-5 -sm-5'),(null as any));
    this._text_100 = this.renderer.createText(this._el_99,'\n                    ',(null as any));
    this._el_101 = import3.createRenderElement(this.renderer,this._el_99,'p',new import3.InlineArray2(2,'class','eva-3-p detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_102 = this.renderer.createText(this._el_101,'',(null as any));
    this._text_103 = this.renderer.createText(this._el_99,'\n                ',(null as any));
    this._text_104 = this.renderer.createText(this._el_91,'\n                ',(null as any));
    this._el_105 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -sm-2'),(null as any));
    this._text_106 = this.renderer.createText(this._el_105,'\n                    ',(null as any));
    this._el_107 = import3.createRenderElement(this.renderer,this._el_105,'p',new import3.InlineArray2(2,'class','eva-3-p detail-text -eva-3-tc-gray-3'),(null as any));
    this._text_108 = this.renderer.createText(this._el_105,'\n                ',(null as any));
    this._text_109 = this.renderer.createText(this._el_91,'\n            ',(null as any));
    this._text_110 = this.renderer.createText(this._el_89,'\n            ',(null as any));
    this._anchor_111 = this.renderer.createTemplateAnchor(this._el_89,(null as any));
    this._vc_111 = new import14.ViewContainer(111,89,this,this._anchor_111);
    this._TemplateRef_111_5 = new import18.TemplateRef_(this,111,this._anchor_111);
    this._NgFor_111_6 = new import21.Wrapper_NgFor(this._vc_111.vcRef,this._TemplateRef_111_5,this.parentView.injectorGet(import22.IterableDiffers,this.parentIndex),this.ref);
    this._text_112 = this.renderer.createText(this._el_89,'\n        ',(null as any));
    this._text_113 = this.renderer.createText(this._el_87,'\n    ',(null as any));
    this._text_114 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_32,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_32));
    this._pipe_translate_4 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_59,new import3.InlineArray4(4,'modelChange',(null as any),'onChange',(null as any)),this.eventHandler(this.handleEvent_59));
    this._SelectContainerComponent_59_3.subscribe(this,this.eventHandler(this.handleEvent_59),true,true);
    this._pipe_translate_8 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_65,new import3.InlineArray4(4,'modelChange',(null as any),'onChange',(null as any)),this.eventHandler(this.handleEvent_65));
    this._SelectContainerComponent_65_3.subscribe(this,this.eventHandler(this.handleEvent_65),true,true);
    this._pipe_translate_10 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_11 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_71,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_71));
    this._pipe_translate_12 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_13 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_82,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_82));
    this._pipe_translate_14 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_15 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_16 = new import13.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._anchor_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._text_73,
      this._text_74,
      this._text_75,
      this._anchor_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._text_84,
      this._text_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._text_97,
      this._text_98,
      this._el_99,
      this._text_100,
      this._el_101,
      this._text_102,
      this._text_103,
      this._text_104,
      this._el_105,
      this._text_106,
      this._el_107,
      this._text_108,
      this._text_109,
      this._text_110,
      this._anchor_111,
      this._text_112,
      this._text_113,
      this._text_114
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 18)))) { return this._NgClass_2_3.context; }
    if (((token === import11.CheckboxContainerComponent) && ((32 <= requestNodeIndex) && (requestNodeIndex <= 33)))) { return this._CheckboxContainerComponent_32_3.context; }
    if (((token === import18.TemplateRef) && (36 === requestNodeIndex))) { return this._TemplateRef_36_5; }
    if (((token === import26.NgFor) && (36 === requestNodeIndex))) { return this._NgFor_36_6.context; }
    if (((token === import25.NgClass) && ((28 <= requestNodeIndex) && (requestNodeIndex <= 40)))) { return this._NgClass_28_3.context; }
    if (((token === import15.SelectContainerComponent) && ((59 <= requestNodeIndex) && (requestNodeIndex <= 60)))) { return this._SelectContainerComponent_59_3.context; }
    if (((token === import15.SelectContainerComponent) && ((65 <= requestNodeIndex) && (requestNodeIndex <= 66)))) { return this._SelectContainerComponent_65_3.context; }
    if (((token === import18.TemplateRef) && (76 === requestNodeIndex))) { return this._TemplateRef_76_5; }
    if (((token === import19.NgIf) && (76 === requestNodeIndex))) { return this._NgIf_76_6.context; }
    if (((token === import18.TemplateRef) && (111 === requestNodeIndex))) { return this._TemplateRef_111_5; }
    if (((token === import26.NgFor) && (111 === requestNodeIndex))) { return this._NgFor_111_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_132(!!this.context.errors['posBh']);
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_28_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_28_3.check_klass(currVal_28_0_0,throwOnChange,false);
    const currVal_28_0_1:any = this._map_141(!!this.context.bhValidations.errors['days']);
    this._NgClass_28_3.check_ngClass(currVal_28_0_1,throwOnChange,false);
    this._NgClass_28_3.ngDoCheck(this,this._el_28,throwOnChange);
    const currVal_32_0_0:any = 'DAYS';
    this._CheckboxContainerComponent_32_3.check_name(currVal_32_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_32_0_1:any = valUnwrapper.unwrap(this._pipe_translate_4.transform('common.ALL'));
    this._CheckboxContainerComponent_32_3.check_label(currVal_32_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_32_0_2:any = 'sm';
    this._CheckboxContainerComponent_32_3.check_size(currVal_32_0_2,throwOnChange,false);
    this._CheckboxContainerComponent_32_3.ngDoCheck(this,this._el_32,throwOnChange);
    const currVal_36_0_0:any = this.context.data.days;
    this._NgFor_36_6.check_ngForOf(currVal_36_0_0,throwOnChange,false);
    this._NgFor_36_6.ngDoCheck(this,this._anchor_36,throwOnChange);
    const currVal_59_0_0:any = 'hour_from_1';
    this._SelectContainerComponent_59_3.check_id(currVal_59_0_0,throwOnChange,false);
    const currVal_59_0_1:any = 'hour_from_1';
    this._SelectContainerComponent_59_3.check_name(currVal_59_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_59_0_2:any = valUnwrapper.unwrap(this._pipe_translate_8.transform('common.FROM'));
    this._SelectContainerComponent_59_3.check_label(currVal_59_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_59_0_3:any = 'md';
    this._SelectContainerComponent_59_3.check_size(currVal_59_0_3,throwOnChange,false);
    const currVal_59_0_4:boolean = !!this.context.bhValidations.errors['hours1'];
    this._SelectContainerComponent_59_3.check_invalid(currVal_59_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_59_0_5:any = valUnwrapper.unwrap(this._pipe_translate_9.transform(this.context.bhValidations.errors['hours1']));
    this._SelectContainerComponent_59_3.check_invalidText(currVal_59_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_59_0_6:any = this.context.data.hours;
    this._SelectContainerComponent_59_3.check_list(currVal_59_0_6,throwOnChange,false);
    const currVal_59_0_7:any = this.context.dto.hourFrom;
    this._SelectContainerComponent_59_3.check_model(currVal_59_0_7,throwOnChange,false);
    this._SelectContainerComponent_59_3.ngDoCheck(this,this._el_59,throwOnChange);
    const currVal_65_0_0:any = 'hour_from_2';
    this._SelectContainerComponent_65_3.check_id(currVal_65_0_0,throwOnChange,false);
    const currVal_65_0_1:any = 'hour_from_2';
    this._SelectContainerComponent_65_3.check_name(currVal_65_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_65_0_2:any = valUnwrapper.unwrap(this._pipe_translate_10.transform('common.TO'));
    this._SelectContainerComponent_65_3.check_label(currVal_65_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_65_0_3:any = 'md';
    this._SelectContainerComponent_65_3.check_size(currVal_65_0_3,throwOnChange,false);
    const currVal_65_0_4:boolean = !!this.context.bhValidations.errors['hours1'];
    this._SelectContainerComponent_65_3.check_invalid(currVal_65_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_65_0_5:any = valUnwrapper.unwrap(this._pipe_translate_11.transform(this.context.bhValidations.errors['hours1']));
    this._SelectContainerComponent_65_3.check_invalidText(currVal_65_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_65_0_6:any = this.context.data.hours;
    this._SelectContainerComponent_65_3.check_list(currVal_65_0_6,throwOnChange,false);
    const currVal_65_0_7:any = this.context.dto.hourTo;
    this._SelectContainerComponent_65_3.check_model(currVal_65_0_7,throwOnChange,false);
    this._SelectContainerComponent_65_3.ngDoCheck(this,this._el_65,throwOnChange);
    const currVal_76_0_0:any = this.context.dto.hasSecondTime;
    this._NgIf_76_6.check_ngIf(currVal_76_0_0,throwOnChange,false);
    this._NgIf_76_6.ngDoCheck(this,this._anchor_76,throwOnChange);
    const currVal_111_0_0:any = this.context.dto.businessHours;
    this._NgFor_111_6.check_ngForOf(currVal_111_0_0,throwOnChange,false);
    this._NgFor_111_6.ngDoCheck(this,this._anchor_111,throwOnChange);
    this._vc_36.detectChangesInNestedViews(throwOnChange);
    this._vc_76.detectChangesInNestedViews(throwOnChange);
    this._vc_111.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_133:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.DAYS_HOURS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_133,currVal_133))) {
      this.renderer.setText(this._text_9,currVal_133);
      this._expr_133 = currVal_133;
    }
    valUnwrapper.reset();
    const currVal_135:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.DAYS_HOURS_INFORMATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_135,currVal_135))) {
      this.renderer.setText(this._text_12,currVal_135);
      this._expr_135 = currVal_135;
    }
    valUnwrapper.reset();
    const currVal_137:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform(this.context.errorMessages['posBh'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_137,currVal_137))) {
      this.renderer.setText(this._text_17,currVal_137);
      this._expr_137 = currVal_137;
    }
    valUnwrapper.reset();
    const currVal_139:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('pointOfSale.BUSINESS_DAYS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_139,currVal_139))) {
      this.renderer.setText(this._text_25,currVal_139);
      this._expr_139 = currVal_139;
    }
    const currVal_142:any = 'ALL';
    if (import3.checkBinding(throwOnChange,this._expr_142,currVal_142)) {
      this.renderer.setElementProperty(this._el_32,'value',currVal_142);
      this._expr_142 = currVal_142;
    }
    valUnwrapper.reset();
    const currVal_144:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform(this.context.bhValidations.errors['days'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_144,currVal_144))) {
      this.renderer.setText(this._text_39,currVal_144);
      this._expr_144 = currVal_144;
    }
    valUnwrapper.reset();
    const currVal_146:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('pointOfSale.BUSINESS_HOURS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_146,currVal_146))) {
      this.renderer.setText(this._text_48,currVal_146);
      this._expr_146 = currVal_146;
    }
    valUnwrapper.reset();
    const currVal_148:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('pointOfSale.BUSINESS_HOURS_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_148,currVal_148))) {
      this.renderer.setText(this._text_51,currVal_148);
      this._expr_148 = currVal_148;
    }
    valUnwrapper.reset();
    const currVal_154:any = import3.inlineInterpolate(1,'\n                ',(!this.context.dto.hasSecondTime? valUnwrapper.unwrap(this._pipe_translate_12.transform('pointOfSale.ADD_HOURS')): valUnwrapper.unwrap(this._pipe_translate_13.transform('pointOfSale.QUIT_HOURS'))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_154,currVal_154))) {
      this.renderer.setText(this._text_72,currVal_154);
      this._expr_154 = currVal_154;
    }
    valUnwrapper.reset();
    const currVal_157:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_14.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_157,currVal_157))) {
      this.renderer.setText(this._text_83,currVal_157);
      this._expr_157 = currVal_157;
    }
    const currVal_159:boolean = (!this.context.dto.businessHours || (!!this.context.dto.businessHours && (this.context.dto.businessHours.length == 0)));
    if (import3.checkBinding(throwOnChange,this._expr_159,currVal_159)) {
      this.renderer.setElementProperty(this._el_87,'hidden',currVal_159);
      this._expr_159 = currVal_159;
    }
    valUnwrapper.reset();
    const currVal_160:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('common.DAYS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_160,currVal_160))) {
      this.renderer.setText(this._text_96,currVal_160);
      this._expr_160 = currVal_160;
    }
    valUnwrapper.reset();
    const currVal_162:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('pointOfSale.BUSINESS_HOURS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_162,currVal_162))) {
      this.renderer.setText(this._text_102,currVal_162);
      this._expr_162 = currVal_162;
    }
    this.compView_32.internalDetectChanges(throwOnChange);
    this.compView_59.internalDetectChanges(throwOnChange);
    this.compView_65.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_32_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_59_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_65_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_36.destroyNestedViews();
    this._vc_76.destroyNestedViews();
    this._vc_111.destroyNestedViews();
    this.compView_32.destroy();
    this.compView_59.destroy();
    this.compView_65.destroy();
    this._CheckboxContainerComponent_32_3.ngOnDestroy();
    this._SelectContainerComponent_59_3.ngOnDestroy();
    this._SelectContainerComponent_65_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 36)) { return new View_BusinessHoursComponent1(this.viewUtils,this,36,this._anchor_36,this._vc_36); }
    if ((nodeIndex == 76)) { return new View_BusinessHoursComponent2(this.viewUtils,this,76,this._anchor_76,this._vc_76); }
    if ((nodeIndex == 111)) { return new View_BusinessHoursComponent3(this.viewUtils,this,111,this._anchor_111,this._vc_111); }
    return (null as any);
  }
  handleEvent_32(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.checkAll($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_59(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.hourFrom = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'onChange')) {
      const pd_sub_1:any = ((<any>this.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_65(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.hourTo = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'onChange')) {
      const pd_sub_1:any = ((<any>this.context.updateValidations()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_71(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      this.context.dto.hasSecondTime = !this.context.dto.hasSecondTime;
      this.context.dto.hourFrom2 = (null as any);
      const pd_sub_0:any = ((<any>(this.context.dto.hourTo2 = (null as any))) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_82(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.addBusinessHour()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/edit/business-hours/business-hours.component.ngfactory.ts